import { useEffect } from "react";
import CardTreatment from "./CardTreatment";

function TreatmentsSelector({ treatments, setTreatments, isBreakfast }) {
  const emptyTreatment = {
    name: "",
    pricePerPerson: "",
    pricePerChildren: "",
    disabled: false,
  };

  const addNew = () => {
    setTreatments([...treatments, emptyTreatment]);
  };

  const removeCard = (index) => {
    var tmp = treatments.filter((item, i) => i != index);
    if (tmp.length == 0) tmp = [emptyTreatment]; //avoid complete erasing of all treatment cards
    setTreatments(tmp);
  };

  const setTreatment = (newValue, index) => {
    const tmp = treatments.slice();
    tmp[index].name = newValue;
    setTreatments(tmp);
  };

  const setPrice = (newValue, index) => {
    const tmp = treatments.slice();
    tmp[index].pricePerPerson = newValue;
    setTreatments(tmp);
  };

  const setChildrenPrice = (newValue, index) => {
    const tmp = treatments.slice();
    tmp[index].pricePerChild = newValue;
    setTreatments(tmp);
  };

  const removeBBtreatment = () => {
    var tmp = treatments.filter((item) => item.name != "BB");
    if (tmp.length == 0) tmp = [emptyTreatment]; //avoid complete erasing of all treatment cards
    setTreatments(tmp);
  };

  const addBBtreatment = () => {
    //prendo l'id del vecchio prima di cancellarlo se presente e lo rimetto sul nuovo
    var tmp = treatments.filter((item) => item.name == "BB");
    var prev_id = tmp && tmp.length > 0 ? tmp[0].id : undefined;
    tmp = treatments.filter((item) => item.name != "BB");
    setTreatments([
      ...tmp,
      {
        id: prev_id,
        name: "BB",
        pricePerPerson: 0,
        pricePerChildren: 0,
        disabled: true,
      },
    ]);
  };

  //reacting to changes in isBreakfast
  useEffect(() => {
    if (isBreakfast) addBBtreatment();
    else removeBBtreatment();
  }, [isBreakfast]);

  return (
    <>
      {treatments?.map((treatment, index) => (
        <CardTreatment
          key={index}
          treatment={treatment}
          setTreatment={(newValue) => setTreatment(newValue, index)}
          setPrice={(newValue) => setPrice(newValue, index)}
          setChildrenPrice={(newValue) => setChildrenPrice(newValue, index)}
          addNew={addNew}
          removeCard={() => removeCard(index)}
          otherTreatmentsSet={treatments.filter((item, i) => i != index)}
          last={index == treatments.length - 1}
        />
      ))}
    </>
  );
}

export default TreatmentsSelector;
